import React, { useState,useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Footer from "../../../components/footer/Footer.js";
import TopButton from "../../../components/topButton/TopButton.js";
import "./Financing.css";
import Navigationbar from "../../../components/header/Navigationbar.jsx";
import Model from "../../../containers/Model/Model.jsx";
import Zoom from 'react-reveal/Zoom';
import WhatsAppCard from "../../contact/WhatsAppCard.jsx";

const Financing = (props) => {
  const theme = props.theme;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isScrollingUp, setIsScrollingUp] = useState(true);
  const [animationShown, setAnimationShown] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleScroll = (event) => {
    setIsScrollingUp(event.deltaY < 0);
  };

  const handleTouchMove = (event) => {
    setIsScrollingUp(event.deltaY < 0);
  };
  useEffect(() => {
    if (isScrollingUp && !animationShown) {
      setAnimationShown(true);
    }

    window.addEventListener('wheel', handleScroll);
    window.addEventListener('touchmove', handleTouchMove);

    return () => {
      window.removeEventListener('wheel', handleScroll);
      window.removeEventListener('touchmove', handleTouchMove);
    };
  }, [isScrollingUp, animationShown]);
  return (
    <div className="educaton-main">
      <Navigationbar theme={theme} />
      <div className="basic-education1">
        <Model open={isModalOpen} onClose={handleCloseModal} />
        <div className="basic-education-services">
          <div className="loanagainstsecurities">
            {isScrollingUp && animationShown ? (
              <>
                <div className="loanagainstsecurities-text">
                  <p className="loanagainstsecurities-text-header">
                    Loan against Securities
                  </p>
                  <p className="loanagainstsecurities-text-main">
                    A Loan Against Securities (LAS) is a financial product that
                    allows individuals to borrow money by pledging their financial
                    securities such as stocks, mutual funds, bonds, or other
                    marketable securities as collateral. This type of loan is a form
                    of secured lending, where the borrower uses their investment
                    portfolio as security for the loan.
                  </p>
                  <p className="loanagainstsecurities-text-main">
                    Borrowers pledge their financial securities as collateral for
                    the loan.The value of the loan is determined based on the market
                    value of the securities provided.Typically includes stocks,
                    mutual funds, bonds, and other marketable securities. The
                    eligibility criteria may vary depending on the lending
                    institution.
                  </p>
                </div>
              </>
            ) : (
              <Zoom>
                <div className="loanagainstsecurities-text">
                  <p className="loanagainstsecurities-text-header">
                    Loan against Securities
                  </p>
                  <p className="loanagainstsecurities-text-main">
                    A Loan Against Securities (LAS) is a financial product that
                    allows individuals to borrow money by pledging their financial
                    securities such as stocks, mutual funds, bonds, or other
                    marketable securities as collateral. This type of loan is a form
                    of secured lending, where the borrower uses their investment
                    portfolio as security for the loan.
                  </p>
                  <p className="loanagainstsecurities-text-main">
                    Borrowers pledge their financial securities as collateral for
                    the loan.The value of the loan is determined based on the market
                    value of the securities provided.Typically includes stocks,
                    mutual funds, bonds, and other marketable securities. The
                    eligibility criteria may vary depending on the lending
                    institution.
                  </p>
                </div>
              </Zoom>
            )}
            {isScrollingUp && animationShown ? (
              <>
                <div className="loanagainstsecurities-card-main">
                  <div className="loanagainstsecurities-card">
                    <img
                      src='/assets/images/loan-against.webp'
                      className="loanagainstsecurities-card-img-top"
                      alt="..."
                    />
                    <div className="loanagainstsecurities-card-body">
                      <h5
                        className="loanagainstsecurities-card-title"
                        style={{ paddingBottom: "10px" }}
                      >
                        Loan against Securities
                      </h5>
                      <div
                        className="cardbutton"
                        style={{ display: "flex", gap: "20px" }}
                      >
                        <button
                          className="broking-applynow"
                          onClick={handleOpenModal}
                        >
                          Apply Now
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <Zoom>
                <div className="loanagainstsecurities-card-main">
                  <div className="loanagainstsecurities-card">
                    <img
                      src='/assets/images/loan-against.webp'
                      className="loanagainstsecurities-card-img-top"
                      alt="..."
                    />
                    <div className="loanagainstsecurities-card-body">
                      <h5
                        className="loanagainstsecurities-card-title"
                        style={{ paddingBottom: "10px" }}
                      >
                        Loan against Securities
                      </h5>
                      <div
                        className="cardbutton"
                        style={{ display: "flex", gap: "20px" }}
                      >
                        <button
                          className="broking-applynow"
                          onClick={handleOpenModal}
                        >
                          Apply Now
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </Zoom>
              )}
          </div>
          <div className="loanagainstcommodities">
            {isScrollingUp && animationShown ? (
              <>
            <div className="loanagainstcommodities-card-main">
              <div className="loanagainstcommodities-card">
                <img
                  src='/assets/images/loanimg.png'
                  className="loanagainstcommodities-card-img-top"
                  alt="..."
                />
                <div className="loanagainstcommodities-card-body">
                  <h5
                    className="loanagainstcommodities-card-title"
                    style={{ paddingBottom: "10px" }}
                  >
                    Loan against Commodities
                  </h5>
                  <div
                    className="cardbutton"
                    style={{ display: "flex", gap: "20px" }}
                  >
                    <button
                      className="broking-applynow"
                      onClick={handleOpenModal}
                    >
                      Apply Now
                    </button>
                  </div>
                </div>
              </div>
            </div>
            </>
            ) : (
              <Zoom>
                <div className="loanagainstcommodities-card-main">
              <div className="loanagainstcommodities-card">
                <img
                  src='/assets/images/loanimg.png'
                  className="loanagainstcommodities-card-img-top"
                  alt="..."
                />
                <div className="loanagainstcommodities-card-body">
                  <h5
                    className="loanagainstcommodities-card-title"
                    style={{ paddingBottom: "10px" }}
                  >
                    Loan against Commodities
                  </h5>
                  <div
                    className="cardbutton"
                    style={{ display: "flex", gap: "20px" }}
                  >
                    <button
                      className="broking-applynow"
                      onClick={handleOpenModal}
                    >
                      Apply Now
                    </button>
                  </div>
                </div>
              </div>
            </div>
              </Zoom>
            )}
            {isScrollingUp && animationShown ? (
              <>
                <div className="loanagainstcommodities-text">
                  <p className="loanagainstcommodities-text-header">
                    Loan against Commodities
                  </p>
                  <p className="loanagainstcommodities-text-main">
                    A Loan Against Commodities (LAC) is a financial arrangement in
                    which individuals or businesses obtain a loan by using physical
                    commodities as collateral. This type of financing allows
                    borrowers to leverage the value of their tangible assets to
                    secure funds.{" "}
                  </p>
                  <p className="loanagainstcommodities-text-main">
                    Borrowers provide tangible goods or commodities as security for
                    the loan.Common collateral includes agricultural products,
                    metals, and other physical goods.The type of commodities
                    accepted as collateral depends on the policies of the lending
                    institution.Eligibility criteria may include factors such as
                    marketability, storage conditions, and market value.
                  </p>
                </div>
              </>
            ) : (
              <Zoom>
                <div className="loanagainstcommodities-text">
                  <p className="loanagainstcommodities-text-header">
                    Loan against Commodities
                  </p>
                  <p className="loanagainstcommodities-text-main">
                    A Loan Against Commodities (LAC) is a financial arrangement in
                    which individuals or businesses obtain a loan by using physical
                    commodities as collateral. This type of financing allows
                    borrowers to leverage the value of their tangible assets to
                    secure funds.{" "}
                  </p>
                  <p className="loanagainstcommodities-text-main">
                    Borrowers provide tangible goods or commodities as security for
                    the loan.Common collateral includes agricultural products,
                    metals, and other physical goods.The type of commodities
                    accepted as collateral depends on the policies of the lending
                    institution.Eligibility criteria may include factors such as
                    marketability, storage conditions, and market value.
                  </p>
                </div>
              </Zoom>
            )}
          </div>
          <div className="ipofinancing">
            {isScrollingUp && animationShown ? (
              <>
                <div className="ipofinancing-text">
                  <p className="ipofinancing-text-header">IPO/NCD Financing</p>
                  <p className="ipofinancing-text-main">
                    IPO (Initial Public Offering) Financing and NCD (Non-Convertible
                    Debenture) Financing are two distinct forms of financial
                    arrangements related to the capital market.
                  </p>
                  <p className="ipofinancing-text-main">
                    IPO Financing involves providing funds to investors to subscribe
                    to shares offered in an Initial Public Offering.Investors may
                    require additional funds to participate in an IPO, especially if
                    they want to subscribe to a large number of shares.IPO Financing
                    allows investors to leverage their existing capital by borrowing
                    funds to apply for more shares in the IPO.
                  </p>
                </div>
              </>
            ) : (
              <Zoom>
                <div className="ipofinancing-text">
                  <p className="ipofinancing-text-header">IPO/NCD Financing</p>
                  <p className="ipofinancing-text-main">
                    IPO (Initial Public Offering) Financing and NCD (Non-Convertible
                    Debenture) Financing are two distinct forms of financial
                    arrangements related to the capital market.
                  </p>
                  <p className="ipofinancing-text-main">
                    IPO Financing involves providing funds to investors to subscribe
                    to shares offered in an Initial Public Offering.Investors may
                    require additional funds to participate in an IPO, especially if
                    they want to subscribe to a large number of shares.IPO Financing
                    allows investors to leverage their existing capital by borrowing
                    funds to apply for more shares in the IPO.
                  </p>
                </div>
              </Zoom>
            )}
            {isScrollingUp && animationShown ? (
              <>
                <div className="ipofinancing-card-main">
                  <div className="ipofinancing-card">
                    <img
                      src='/assets/images/loan-against-property.webp'
                      className="ipofinancing-card-img-top"
                      alt="..."
                    />
                    <div className="ipofinancing-card-body">
                      <h5
                        className="ipofinancing-card-title"
                        style={{ paddingBottom: "10px" }}
                      >
                        IPO/NCD Financing
                      </h5>
                      <div
                        className="cardbutton"
                        style={{ display: "flex", gap: "20px" }}
                      >
                        <button
                          className="broking-applynow"
                          onClick={handleOpenModal}
                        >
                          Apply Now
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <Zoom>
                <div className="ipofinancing-card-main">
                  <div className="ipofinancing-card">
                    <img
                      src='/assets/images/loan-against-property.webp'
                      className="ipofinancing-card-img-top"
                      alt="..."
                    />
                    <div className="ipofinancing-card-body">
                      <h5
                        className="ipofinancing-card-title"
                        style={{ paddingBottom: "10px" }}
                      >
                        IPO/NCD Financing
                      </h5>
                      <div
                        className="cardbutton"
                        style={{ display: "flex", gap: "20px" }}
                      >
                        <button
                          className="broking-applynow"
                          onClick={handleOpenModal}
                        >
                          Apply Now
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </Zoom>
            )}
          </div>
          <div className="loanagainstproperty">
            {isScrollingUp && animationShown ? (
              <>
                <div className="loanagainstproperty-card-main">
                  <div className="loanagainstproperty-card">
                    <img
                      src='/assets/images/IPO.webp'
                      className="loanagainstproperty-card-img-top"
                      alt="..."
                    />
                    <div className="loanagainstproperty-card-body">
                      <h5
                        className="loanagainstproperty-card-title"
                        style={{ paddingBottom: "10px" }}
                      >
                        Loan against Property
                      </h5>
                      <div
                        className="cardbutton"
                        style={{ display: "flex", gap: "20px" }}
                      >
                        <button
                          className="broking-applynow"
                          onClick={handleOpenModal}
                        >
                          Apply Now
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <Zoom>
                <div className="loanagainstproperty-card-main">
              <div className="loanagainstproperty-card">
                <img
                  src='/assets/images/IPO.webp'
                  className="loanagainstproperty-card-img-top"
                  alt="..."
                />
                <div className="loanagainstproperty-card-body">
                  <h5
                    className="loanagainstproperty-card-title"
                    style={{ paddingBottom: "10px" }}
                  >
                    Loan against Property
                  </h5>
                  <div
                    className="cardbutton"
                    style={{ display: "flex", gap: "20px" }}
                  >
                    <button
                      className="broking-applynow"
                      onClick={handleOpenModal}
                    >
                      Apply Now
                    </button>
                  </div>
                </div>
              </div>
            </div>
              </Zoom>
            )}
            {isScrollingUp && animationShown ? (
              <>
                <div className="loanagainstcommodities-text">
                  <p className="loanagainstcommodities-text-header">
                    Loan against Property
                  </p>
                  <p className="loanagainstcommodities-text-main">
                  A Loan Against Property (LAP), also known as a mortgage loan, is a financial product where an individual can pledge their property (residential or commercial) as collateral to secure a loan. This type of financing allows property owners to unlock the value of their real estate assets to meet various financial needs.
                  </p>
                  <p className="loanagainstcommodities-text-main">
                  The property serves as collateral for the loan, providing security to the lender. In case of default, the lender has the right to take possession of the property.The loan amount is determined based on the market value of the property being pledged. Lenders typically offer a percentage of the property's value as the loan amount.
                  </p>
                </div>
              </>
            ) : (
              <Zoom>
                <div className="loanagainstcommodities-text">
                  <p className="loanagainstcommodities-text-header">
                    Loan against Property
                  </p>
                  <p className="loanagainstcommodities-text-main">
                  A Loan Against Property (LAP), also known as a mortgage loan, is a financial product where an individual can pledge their property (residential or commercial) as collateral to secure a loan. This type of financing allows property owners to unlock the value of their real estate assets to meet various financial needs.
                  </p>
                  <p className="loanagainstcommodities-text-main">
                  The property serves as collateral for the loan, providing security to the lender. In case of default, the lender has the right to take possession of the property.The loan amount is determined based on the market value of the property being pledged. Lenders typically offer a percentage of the property's value as the loan amount.
                  </p>
                </div>
              </Zoom>
            )}
          </div>
          <div className="smeloan">
            {isScrollingUp && animationShown ? (
              <>
                <div className="smeloan-text">
                  <p className="smeloan-text-header">SME Loan</p>
                  <p className="smeloan-text-main">
                    A Small and Medium Enterprise (SME) Loan is a financial product
                    specifically tailored to meet the financing needs of small and
                    medium-sized businesses.SME Loans are financial instruments
                    provided by banks and financial institutions to support the
                    capital requirements of small and medium-sized enterprises.
                  </p>
                  <p className="smeloan-text-main">
                    SME Loans are versatile and can be utilized for various business
                    purposes, including working capital, expansion, equipment
                    purchase, technology upgrades, inventory management, and other
                    operational needs.Eligibility is determined by factors such as
                    the business's financial stability, creditworthiness, business
                    plan, and repayment capacity. Lenders may consider both
                    quantitative and qualitative aspects.
                  </p>
                </div>
              </>
            ) : (
              <Zoom>
                <div className="smeloan-text">
              <p className="smeloan-text-header">SME Loan</p>
              <p className="smeloan-text-main">
                A Small and Medium Enterprise (SME) Loan is a financial product
                specifically tailored to meet the financing needs of small and
                medium-sized businesses.SME Loans are financial instruments
                provided by banks and financial institutions to support the
                capital requirements of small and medium-sized enterprises.
              </p>
              <p className="smeloan-text-main">
                SME Loans are versatile and can be utilized for various business
                purposes, including working capital, expansion, equipment
                purchase, technology upgrades, inventory management, and other
                operational needs.Eligibility is determined by factors such as
                the business's financial stability, creditworthiness, business
                plan, and repayment capacity. Lenders may consider both
                quantitative and qualitative aspects.
              </p>
            </div>
              </Zoom>
            )}
            {isScrollingUp && animationShown ? (
              <>
                <div className="smeloan-card-main">
                  <div className="smeloan-card">
                    <img src='/assets/images/SME.jpg' className="smeloan-card-img-top" alt="..." />
                    <div className="smeloan-card-body">
                      <h5
                        className="smeloan-card-title"
                        style={{ paddingBottom: "10px" }}
                      >
                        SME Loan
                      </h5>
                      <div
                        className="cardbutton"
                        style={{ display: "flex", gap: "20px" }}
                      >
                        <button
                          className="broking-applynow"
                          onClick={handleOpenModal}
                        >
                          Apply Now
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <Zoom>
                <div className="smeloan-card-main">
                  <div className="smeloan-card">
                    <img src='/assets/images/SME.jpg' className="smeloan-card-img-top" alt="..." />
                    <div className="smeloan-card-body">
                      <h5
                        className="smeloan-card-title"
                        style={{ paddingBottom: "10px" }}
                      >
                        SME Loan
                      </h5>
                      <div
                        className="cardbutton"
                        style={{ display: "flex", gap: "20px" }}
                      >
                        <button
                          className="broking-applynow"
                          onClick={handleOpenModal}
                        >
                          Apply Now
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </Zoom>
            )}
          </div>
          <div className="medicalequipmentfinancing">
            {isScrollingUp && animationShown ? (
              <>
                <div className="medicalequipmentfinancing-card-main">
                  <div className="medicalequipmentfinancing-card">
                    <img
                      src='/assets/images/Medical.jpg'
                      className="medicalequipmentfinancing-card-img-top"
                      alt="..."
                    />
                    <div className="medicalequipmentfinancing-card-body">
                      <h5
                        className="medicalequipmentfinancing-card-title"
                      >
                        Medical Equipment Financing
                      </h5>
                      <div
                        className="cardbutton"
                        style={{ display: "flex", gap: "20px" }}
                      >
                        <button
                          className="broking-applynow"
                          onClick={handleOpenModal}
                        >
                          Apply Now
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <Zoom>
                <div className="medicalequipmentfinancing-card-main">
              <div className="medicalequipmentfinancing-card">
                <img
                  src='/assets/images/Medical.jpg'
                  className="medicalequipmentfinancing-card-img-top"
                  alt="..."
                />
                <div className="medicalequipmentfinancing-card-body">
                  <h5
                    className="medicalequipmentfinancing-card-title"
                  >
                    Medical Equipment Financing
                  </h5>
                  <div
                    className="cardbutton"
                    style={{ display: "flex", gap: "20px" }}
                  >
                    <button
                      className="broking-applynow"
                      onClick={handleOpenModal}
                    >
                      Apply Now
                    </button>
                  </div>
                </div>
              </div>
            </div>
              </Zoom>
            )}
            {isScrollingUp && animationShown ? (
              <>
                <div className="medicalequipmentfinancing-text">
                  <p className="medicalequipmentfinancing-text-header">
                    Medical Equipment Financing
                  </p>
                  <p className="medicalequipmentfinancing-text-main">
                    Medical Equipment Financing is a specialized form of financing
                    designed to assist healthcare providers and organizations in
                    acquiring the necessary medical equipment for their operations.
                  </p>
                  <p className="medicalequipmentfinancing-text-main">
                    {" "}
                    Medical Equipment Financing is specifically intended for the
                    acquisition of medical devices, machinery, and technology
                    required for healthcare services.Funding can be used to acquire
                    a wide range of medical equipment, including diagnostic tools,
                    imaging devices, surgical instruments, laboratory equipment,
                    patient monitoring systems, and other healthcare-related
                    machinery.
                  </p>
                </div>
              </>
            ) : (
              <Zoom>
                <div className="medicalequipmentfinancing-text">
                  <p className="medicalequipmentfinancing-text-header">
                    Medical Equipment Financing
                  </p>
                  <p className="medicalequipmentfinancing-text-main">
                    Medical Equipment Financing is a specialized form of financing
                    designed to assist healthcare providers and organizations in
                    acquiring the necessary medical equipment for their operations.
                  </p>
                  <p className="medicalequipmentfinancing-text-main">
                    {" "}
                    Medical Equipment Financing is specifically intended for the
                    acquisition of medical devices, machinery, and technology
                    required for healthcare services.Funding can be used to acquire
                    a wide range of medical equipment, including diagnostic tools,
                    imaging devices, surgical instruments, laboratory equipment,
                    patient monitoring systems, and other healthcare-related
                    machinery.
                  </p>
                </div>
              </Zoom>
            )}
          </div>
          <div className="personalloan">
            {isScrollingUp && animationShown ? (
              <>
                <div className="personalloan-text">
                  <p className="personalloan-text-header">Personal Loan</p>
                  <p className="personalloan-text-main">
                    Personal Loan Financing is a type of unsecured loan that
                    individuals can obtain from banks, credit unions, or other
                    financial institutions to meet various personal financial
                    needs.Personal loans are typically unsecured, meaning they do
                    not require collateral. Approval is based on the borrower's
                    creditworthiness and financial history.
                  </p>
                  <p className="personalloan-text-main">
                    Personal loans can be used for a variety of purposes, including
                    debt consolidation, home improvements, education expenses,
                    medical bills, travel, or other personal expenses.Lenders assess
                    borrowers based on factors such as credit score, income,
                    employment history, and debt-to-income ratio to determine
                    eligibility for a personal loan.
                  </p>
                </div>
              </>
            ) : (
              <Zoom>
                <div className="personalloan-text">
                  <p className="personalloan-text-header">Personal Loan</p>
                  <p className="personalloan-text-main">
                    Personal Loan Financing is a type of unsecured loan that
                    individuals can obtain from banks, credit unions, or other
                    financial institutions to meet various personal financial
                    needs.Personal loans are typically unsecured, meaning they do
                    not require collateral. Approval is based on the borrower's
                    creditworthiness and financial history.
                  </p>
                  <p className="personalloan-text-main">
                    Personal loans can be used for a variety of purposes, including
                    debt consolidation, home improvements, education expenses,
                    medical bills, travel, or other personal expenses.Lenders assess
                    borrowers based on factors such as credit score, income,
                    employment history, and debt-to-income ratio to determine
                    eligibility for a personal loan.
                  </p>
                </div>
              </Zoom>
            )}
            {isScrollingUp && animationShown ? (
              <>
                <div className="personalloan-card-main">
                  <div className="personalloan-card">
                    <img
                      src='/assets/images/personal-loan.jpg'
                      className="personalloan-card-img-top"
                      alt="..."
                    />
                    <div className="personalloan-card-body">
                      <h5
                        className="personalloan-card-title"
                        style={{ paddingBottom: "10px" }}
                      >
                        Personal Loan
                      </h5>
                      <div
                        className="cardbutton"
                        style={{ display: "flex", gap: "20px" }}
                      >
                        <button
                          className="broking-applynow"
                          onClick={handleOpenModal}
                        >
                          Apply Now
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <Zoom>
                <div className="personalloan-card-main">
                  <div className="personalloan-card">
                    <img
                      src='/assets/images/personal-loan.jpg'
                      className="personalloan-card-img-top"
                      alt="..."
                    />
                    <div className="personalloan-card-body">
                      <h5
                        className="personalloan-card-title"
                        style={{ paddingBottom: "10px" }}
                      >
                        Personal Loan
                      </h5>
                      <div
                        className="cardbutton"
                        style={{ display: "flex", gap: "20px" }}
                      >
                        <button
                          className="broking-applynow"
                          onClick={handleOpenModal}
                        >
                          Apply Now
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </Zoom>
            )}
          </div>
        </div>
      </div>
      <Footer theme={props.theme} onToggle={props.onToggle} />
      <TopButton theme={props.theme} />
      <WhatsAppCard/>
    </div>
  );
};

export default Financing;
